import requester from '@/lib/axios';
import { CodeEditorTestCase } from '@/models/CodeEditorActivity';
import JsonApiResponse from '@/models/JsonApiResponse';
import { BaseFilters } from '@/models/Service';

const BASE_URL = 'code-editor-test-cases';

export type ListCodeEditorTestCasesParams = BaseFilters &
  Partial<{
    codeEditorActivityId: number;
  }>;

export const listCodeEditorTestCases = async (
  params: ListCodeEditorTestCasesParams,
) => {
  const { data } = await requester().get<JsonApiResponse<CodeEditorTestCase>>(
    `${BASE_URL}/`,
    {
      params,
    },
  );

  return data;
};

export type CodeEditorTestCasePayload = {
  codeEditorActivityId: number;
  input: string;
  expectedOutput: string;
};

export const createCodeEditorTestCase = async (
  body: CodeEditorTestCasePayload,
) => {
  const { data } = await requester().post<CodeEditorTestCase>(
    `${BASE_URL}/`,
    body,
  );

  return data;
};

export const updateCodeEditorTestCase = async (
  id: number,
  body: Partial<CodeEditorTestCasePayload>,
) => {
  const { data } = await requester().patch<CodeEditorTestCase>(
    `${BASE_URL}/${id}/`,
    body,
  );

  return data;
};

export const deleteCodeEditorTestCase = async (id: number) => {
  await requester().delete(`${BASE_URL}/${id}/`);
};
